(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.phases.phase
   * @description
   *
   */
  angular
    .module('neo.home.phases.phase', [
      'ui.router',
      'neo.home.phases.phase.inscribedTeams'
    ]);
}());
